import classNames from "classnames/bind";
import React from "react";
import { TitleFrontMatter } from "types/graphql";
import Section from "../section";

type titleProps = Omit<TitleFrontMatter, "format"> & {
  content?: string;
  className?: string
};
const titleIntro = ({ title, content, className }: titleProps) => {
  return (
    <Section className={classNames("text-center", className)} full>
      {title && <h1 className={content ? "mb-6 transition-text" : "transition-text"} data-aos="custom">
        <span className="transition-content" dangerouslySetInnerHTML={{ __html: title }}/>
        <span className="transition-layer"/>
      </h1>}
      {content && (
        <div
          className="titleintro-content transition-content"
          data-aos="custom"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </Section>
  );
};

export default titleIntro;
